import { render } from "./ProfileAboutMe.vue?vue&type=template&id=36d650db&scoped=true"
import script from "./ProfileAboutMe.vue?vue&type=script&lang=js"
export * from "./ProfileAboutMe.vue?vue&type=script&lang=js"

import "./ProfileAboutMe.vue?vue&type=style&index=0&id=36d650db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d650db"]])

export default __exports__